import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import {
  FormGroup,
  Form,
  Input,
  Label,
  Button,
  Spinner,
  InputGroupText,
  InputGroup,
} from 'reactstrap';
import { Container } from './style';
import { api } from './../../services/api';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import './style.css';
import { BsPerson } from 'react-icons/bs';

export const ForgotPassword = (): React.JSX.Element => {
  const [email, setEmail] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [succesfullSentEmail, setSuccessfullSentEmail] = useState(false);
  // const { signIn, loading } = useAuth();
  async function handleSubmitLogin(): Promise<void> {
    if (email.length < 1) {
      setErrorEmail('Email obrigatório.');
    } else if (!email.includes('@')) {
      setErrorEmail('É necessário um email válido.');
    } else if (email.split('@')[1] === '') {
      setErrorEmail('É necessário um email válido.');
    } else {
      setErrorEmail('');
    }
    // if (cpf.length === 14 && password !== '' && password.length >= 8) {
    if (email !== '') {
      // localStorage.setItem('inputValueCpf', cpf);
      // localStorage.setItem('inputValuePassword', password);
      await sendEmail();
    }
  }
  // useEffect(() => {
  //   setCPF(localStorage.getItem('inputValueCpf') as unknown as string);
  //   setPassword(localStorage.getItem('inputValuePassword') as unknown as string);
  // }, []);

  async function sendEmail(): Promise<void> {
    try {
      setLoading(true);
      const resetPassword = await api.post('auth/forgot-password', {
        email,
      });
      toast('Email enviado!', { type: 'success' });
      setSuccessfullSentEmail(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // @ts-expect-error error
      if (error?.response?.status === 400) {
        toast('Email não encontrado!', { type: 'error' });
        console.log(error);
      } else {
        toast('Um erro foi encontrado, contate o administrador do sistema, ou tente novamente', {
          type: 'error',
        });
        console.log(error);
      }
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#edf3ff',
      }}
    >
      {/* Imagem lateral */}
      <div
        className="d-none d-md-block"
        style={{
          width: '50%',
          height: '100vh',
        }}
      >
        <img
          src="/assets/sideImage.png"
          alt="icone-amapa"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Formulário */}
      <div
        className="col-sm"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div
          className="col-sm-7"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 20,
            height: '100%',
            marginTop: -90,
          }}
        >
          {/* Logo */}
          <div>
            <img
              src="/assets/logo.png"
              alt="icone-amapa"
              className="logo"
              // style={{
              //   width: '100%', // ocupa todo o espaço possível
              //   maxWidth: '330px', // não passa disso
              //   height: 'auto', // mantém proporção
              //   objectFit: 'cover',
              // }}
            />
          </div>

          {/* Card do formulário */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff',
              borderRadius: 12,
              padding: '30px 20px',
              width: '100%',
              maxWidth: 562,
              minHeight: 400,
              gap: 20,
              justifyContent: 'center',
            }}
          >
            {!succesfullSentEmail ? (
              <>
                <div style={{ marginBottom: 25, textAlign: 'center' }}>
                  <h5 style={{ fontWeight: 500, fontSize: 45 }}>Recuperação de senha!</h5>
                  <span>Informe o email cadastrado para solicitar a recuperação de senha.</span>
                </div>

                <Form style={{ width: '100%' }}>
                  {/* <FormGroup>
                <p style={{ textAlign: 'center', fontSize: 17, width: '100%' }}>
                  Informe seu email cadastrado no sistema para
                  <br /> enviarmos as instruções de redefinição de senha.
                </p>
              </FormGroup> */}
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                      {/* <Label
                  style={{
                    fontWeight: 'bold',
                    color: errorEmail?.length > 1 ? '#E44B39' : '#2C2C2D',
                  }}
                >
                  Email
                </Label> */}
                      <div style={{ marginBottom: 25 }}>
                        {' '}
                        <InputGroup>
                          <InputGroupText
                            className="no-border-right"
                            style={{
                              backgroundColor: 'transparent', // fundo transparente
                              color: '#2A2C85', // cor do ícone
                              borderRight: 'none', // remove a borda da direita
                              borderColor: errorEmail?.length > 1 ? '#E44B39' : '#989898',
                            }}
                          >
                            <BsPerson />
                          </InputGroupText>
                          <Input
                            className="no-border-left"
                            style={{
                              borderColor: errorEmail?.length > 1 ? '#E44B39' : '#989898',
                              height: 48,
                            }}
                            id="exampleEmail"
                            name="email"
                            value={email}
                            placeholder="Insira seu email"
                            type="text"
                            onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                            onKeyPress={async (e) => {
                              if (e.charCode === 13) {
                                if (!loading) {
                                  await handleSubmitLogin();
                                }
                              }
                            }}
                          />
                        </InputGroup>
                        <text
                          style={{
                            fontSize: 14,
                            color: '#E44B39',
                            marginBottom: 5,
                          }}
                        >
                          {errorEmail}
                        </text>
                      </div>
                    </FormGroup>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Button
                      disabled={loading}
                      // eslint-disable-next-line @typescript-eslint/no-misused-promises
                      onClick={async () => {
                        await handleSubmitLogin();
                      }}
                      style={{
                        width: '100%',
                        maxWidth: 452,
                        backgroundColor: '#2A2C85',
                        color: '#fff',
                        height: 48,
                      }}
                      color="success"
                      size="md"
                    >
                      {loading ? <Spinner type="border" size={'sm'} color="light" /> : 'Enviar'}
                    </Button>{' '}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%',
                      marginTop: 15,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginBottom: 15,
                        gap: 5,
                        color: '#989898',
                      }}
                    >
                      Já sabe seu login?
                      <a
                        style={{ textDecoration: 'none', color: '#2A2C85', fontWeight: 600 }}
                        href="/login"
                      >
                        Entre
                      </a>
                    </div>
                  </div>
                </Form>
              </>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <div style={{ marginBottom: 25, textAlign: 'center' }}>
                  <h5 style={{ fontWeight: 500, fontSize: 45 }}>
                    Enviamos um link para o e-mail cadastrado!
                  </h5>
                  <span>Verifique seu email!</span>
                </div>

                <Form style={{ width: '100%' }}>
                  {/* <FormGroup>
                <p style={{ textAlign: 'center', fontSize: 17, width: '100%' }}>
                  Informe seu email cadastrado no sistema para
                  <br /> enviarmos as instruções de redefinição de senha.
                </p>
              </FormGroup> */}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%',
                      marginTop: 15,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginBottom: 15,
                        gap: 5,
                        color: '#989898',
                      }}
                    >
                      Já sabe seu login?
                      <a style={{ textDecoration: 'none', color: '#2A2C85' }} href="/login">
                        Entre
                      </a>
                    </div>
                  </div>
                </Form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
